import { styled, CSSObject, Theme } from '@mui/material/styles'
import MuiDrawer from '@mui/material/Drawer'

export const DRAWER_WIDTH = 240

const drawerPaperStyles: CSSObject = {
  background: 'rgba(15, 23, 42, 0.95)',
  backdropFilter: 'blur(24px)',
  borderRight: '1px solid rgba(168, 85, 247, 0.2)',
  boxShadow: '4px 0 24px rgba(0, 0, 0, 0.5), inset -1px 0 0 rgba(168, 85, 247, 0.1)',
}

const openedMixin = (theme: Theme): CSSObject => ({
  width: DRAWER_WIDTH,
  position: 'fixed',
  height: '100vh',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  ...drawerPaperStyles,
})

const closedMixin = (theme: Theme): CSSObject => ({
  position: 'fixed',
  height: '100vh',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  ...drawerPaperStyles,
})

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  minHeight: '64px',
  background: 'linear-gradient(135deg, rgba(147, 51, 234, 0.08) 0%, rgba(236, 72, 153, 0.08) 100%)',
  borderBottom: '1px solid rgba(168, 85, 247, 0.1)',
}))

const Drawer = styled(MuiDrawer)(({ theme, open, variant }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  // For temporary (mobile) drawer - let MUI handle positioning, just style the paper
  ...(variant === 'temporary' && {
    '& .MuiDrawer-paper': {
      width: DRAWER_WIDTH,
      ...drawerPaperStyles,
    },
  }),
  // For permanent (desktop) drawer - use the open/closed mixins
  ...(variant !== 'temporary' && open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(variant !== 'temporary' && !open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}))

const Spacer = styled('div')({
  flexGrow: 1,
})

export const SideDrawerElements = {
  Drawer,
  DrawerHeader,
  Spacer,
}